import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField, Checkbox, FormControlLabel, Grid, Button } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as validatorActions from '../../components/validator/store/actions'
import * as Actions from './store/actions';
import ComponentTrackingInfo from '../../components/ComponentTrackingInfo';
import { getSharedTextFieldProps } from '../../components/helpers';
import ContentLabelForm from '../content_label/ContentLabelForm';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
    editor: {
        "min-height": "150px"
    },
    root: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
    readOnlyMargin: {
        marginLeft: '16px'
    },
    hiddenWhenEmptyValue: {
        display: 'none'
    }
});


class ModuleForm extends Component {
    state = {
    }

    handleChange = field_name => event => {

        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        const update_data = {
            [field_name]: value
        }
        const validator = {
            field_name, value
        }

        this.props.runValidator(validator)
        this.props.updateModuleForm(update_data);
    }

    render() {
        const { classes, view_type, theme, module, validator } = this.props;
        return (
            <div className="p-24">
                <Grid container spacing={24}>
                    <Grid item xs={6}>
                        <form className={classes.container} noValidate autoComplete="off">
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="ModuleName"
                                    label="Module Name"
                                    value={module.ModuleName}
                                    onChange={this.handleChange('ModuleName')}
                                    error={validator.filter(v => v.field_name === 'ModuleName')[0].error}
                                    helperText={validator.filter(v => v.field_name === 'ModuleName')[0].error_msg}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="ModuleDescription"
                                    label="Module Description"
                                    value={module.ModuleDescription}
                                    onChange={this.handleChange('ModuleDescription')}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                    className={(module.ModuleDescription === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField] : classes.textField}

                                />
                            </Grid>
                            {/* <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(module.Active === 1 || module.Active === true)}
                                            onChange={(view_type === 'detail') ? undefined : this.handleChange('Active')}
                                            disableRipple={view_type === 'detail'}
                                            value="Active"
                                            color="primary"
                                        />
                                    }
                                    label="Active"
                                />
                            </Grid> */}
                            <Grid item xs={12} style={{ paddingTop: '20px' }}>
                                <ContentLabelForm
                                    labelList={this.props.contentLabelList}
                                    component_reference={'module'}
                                    component_reference_id={module.module_id}
                                    baseComponent={module}
                                    updateFunction={this.props.updateModuleForm}
                                    view_type={view_type}
                                />
                            </Grid>
                        </form>
                    </Grid>
                    <Grid item xs={4}>
                        <ComponentTrackingInfo
                            editInfo={this.props.editInfo}
                            view_type={this.props.view_type}
                            classes={classes}
                        />
                    </Grid>
                </Grid>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getModule: Actions.getModule,
        deleteModule: Actions.deleteModule,
        saveModule: Actions.saveModule,
        updateModuleForm: Actions.updateModuleForm,
        toggleLesson: Actions.toggleLesson,
        toggleCourse: Actions.toggleCourse,
        runValidator: validatorActions.runValidator
    }, dispatch);
}

function mapStateToProps({ moduleApp, validator, contentLabelReducer }) {
    return {
        module: moduleApp.modules.currentModule,
        validator: validator.list,
        editInfo: moduleApp.modules.editInfo,
        contentLabelList: contentLabelReducer.contentLabelReducer.contentLabelList,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ModuleForm)));



// WEBPACK FOOTER //
// src/main/content/module/ModuleForm.js